export default __webpack_public_path__ + "static/media/Boots of the Riftcaller.7d5b483d.jpg";